import React from "react";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import styles from "../styles/ConfigEditors.module.css";
import { TEMPLATE_EMOJI_PRESETS } from "../constants";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

function TemplatesSectionBody({ state, actions }) {
  const { templatesConfig, templatesLoading, templatesSaving, templatesDirty, prompts } = state;

  return (
    <>
      <div className={styles.row}>
        <input
          type="number"
          className={panelStyles.input}
          value={Number(templatesConfig?.pageSize || 5)}
          onChange={(event) => actions.updateConfig({ pageSize: Number(event.target.value) })}
          placeholder="Кнопок на страницу"
        />
      </div>

      <div className={styles.row}>
        <button
          type="button"
          className={panelStyles.buttonSecondary}
          onClick={actions.reload}
          disabled={templatesLoading}
        >
          {templatesLoading ? "Обновляем..." : "Перезагрузить"}
        </button>
        <button
          type="button"
          className={panelStyles.button}
          onClick={actions.save}
          disabled={!templatesDirty || templatesSaving}
        >
          {templatesSaving ? "Сохраняем..." : "Сохранить"}
        </button>
      </div>

      <button type="button" className={panelStyles.buttonSecondary} onClick={actions.addPrompt}>
        Добавить шаблон
      </button>

      {prompts.length > 0 ? (
        <div className={styles.cardList}>
          {prompts.map((item, index) => (
            <div key={item.id || `template-${index}`} className={styles.card}>
              <div className={styles.cardHeader}>
                <strong>{item.title || `Шаблон #${index + 1}`}</strong>
                <div className={styles.cardActions}>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.movePrompt(index, "up")}
                    disabled={index === 0}
                  >
                    Вверх
                  </button>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.movePrompt(index, "down")}
                    disabled={index === prompts.length - 1}
                  >
                    Вниз
                  </button>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.removePrompt(index)}
                  >
                    Удалить
                  </button>
                </div>
              </div>

              <div className={styles.emojiGrid}>
                {TEMPLATE_EMOJI_PRESETS.map((emoji) => (
                  <button
                    key={`${emoji}-${index}`}
                    type="button"
                    className={joinClasses(styles.emojiChip, item.emoji === emoji ? styles.tabActive : "")}
                    onClick={() => actions.updatePrompt(index, { emoji })}
                  >
                    {emoji}
                  </button>
                ))}
              </div>

              <div className={styles.row}>
                <input
                  type="text"
                  className={panelStyles.input}
                  value={item.emoji || ""}
                  placeholder="Эмодзи"
                  onChange={(event) => actions.updatePrompt(index, { emoji: event.target.value })}
                />
                <input
                  type="text"
                  className={panelStyles.input}
                  value={item.title || ""}
                  placeholder="Название"
                  onChange={(event) => actions.updatePrompt(index, { title: event.target.value })}
                />
              </div>

              <select
                className={panelStyles.select}
                value={item.active === false ? "0" : "1"}
                onChange={(event) => actions.updatePrompt(index, { active: event.target.value === "1" })}
              >
                <option value="1">Активен</option>
                <option value="0">Скрыт</option>
              </select>

              <textarea
                rows={6}
                className={panelStyles.textarea}
                value={item.prompt || ""}
                placeholder="Системный промпт"
                onChange={(event) => actions.updatePrompt(index, { prompt: event.target.value })}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.empty}>Шаблоны еще не настроены.</div>
      )}
    </>
  );
}

export function TemplatesSection({ mode = "panel", isOpen = true, onToggle, state, actions }) {
  if (mode === "page") {
    return <TemplatesSectionBody state={state} actions={actions} />;
  }

  return (
    <AdminPanel id="templates" title="Шаблоны" isOpen={isOpen} onToggle={onToggle}>
      <TemplatesSectionBody state={state} actions={actions} />
    </AdminPanel>
  );
}

export default TemplatesSection;
